import Option from 'react-select/lib/Option.js';
import React from 'react';

export default class OptionOverride extends Option {
  render() {
    if (this.props.option && this.props.option.hidden) {
      return <div />;
    }

    const option = this.props.option;
    const instancePrefix = this.props.instancePrefix;
    const optionIndex = this.props.optionIndex;
    const className = this.props.className;

    return (
      <div
        className={className}
        style={option.style}
        role="option"
        id={`${instancePrefix}-option-${optionIndex}`}
        title={option.title}
        onClick={(e) => this.props.onSelect(this.props.option, e)}
        onMouseDown={this.handleMouseDown}
        onMouseEnter={this.handleMouseEnter}
        onMouseMove={this.handleMouseMove}
        onTouchStart={this.handleTouchStart}
        onTouchMove={this.handleTouchMove}
        onTouchEnd={this.handleTouchEnd}
      >
        {this.props.children}
      </div>);
  }
}
